import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export function LabeledInput({ id, label, testId, ...props }) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-sm font-medium text-[#2C2424]">{label}</Label>
      <Input id={id} data-testid={testId} className="rmm-input h-11 bg-white" {...props} />
    </div>
  );
}

export function PasswordInput({ id, label, testId, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-sm font-medium text-[#2C2424]">{label}</Label>
      <div className="relative">
        <Input id={id} type={show ? "text" : "password"} data-testid={testId} className="rmm-input h-11 bg-white pr-10" {...props} />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          data-testid={`${testId}-toggle`}
          aria-label={show ? "Hide password" : "Show password"}
          className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-[#8C6A6C] hover:text-[#7A0016]"
        >
          {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
}

export const OrDivider = () => (
  <div className="my-5 flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-[#8C6A6C]">
    <span className="h-px flex-1 bg-[#D4AF37]/40" /> or <span className="h-px flex-1 bg-[#D4AF37]/40" />
  </div>
);
